import { FlexColMd, FlexMd } from 'components/Elements';
import styled from 'styled-components';
import {
    SavedSuccessfullyNotification,
    EditModeSaveNotification,
    LastActivityInModuleWarning,
} from './SharedEditTaskComponents';
import strings from 'strings/strings.json';
import { ActivityType } from 'models/Activity';
import { ErrorNotifierSlim } from 'components/notifiers/ErrorNotifierSlim';
import Button from 'components/buttons/Button';

type EditActivityFormBottomSectionProps = {
    globalErrorMessage: string;
    showLastActivityInModuleWarning: boolean;
    showSavedSuccessfully: boolean;
    showSavedSuccessfullyEditMode: boolean;
    setDeleteAlertOpen: () => void;
    disableDeleteTaskButton: boolean;
    disableSubmitButton: boolean;
    submitting: boolean;
    fullWidth: boolean;
    activityType: ActivityType;
};

export default function EditActivityFormBottomSection({
    globalErrorMessage,
    showLastActivityInModuleWarning,
    setDeleteAlertOpen,
    disableDeleteTaskButton,
    disableSubmitButton,
    submitting,
    showSavedSuccessfully,
    showSavedSuccessfullyEditMode,
    fullWidth,
    activityType,
}: EditActivityFormBottomSectionProps): JSX.Element {
    let deleteButtonTitle = '';
    let saveButtonTitle = '';

    switch (activityType) {
        case ActivityType.LIVE_TRAINING:
            deleteButtonTitle = strings.activityForm.deleteLiveTraining;
            saveButtonTitle = strings.activityForm.saveLiveTraining;
            break;
        case ActivityType.QUESTIONNAIRE:
            deleteButtonTitle = strings.activityForm.deleteQuestionnaire;
            saveButtonTitle = strings.activityForm.saveQuestionnaire;
            break;
        case ActivityType.PRESENTATION_SLIDE:
            deleteButtonTitle = strings.activityForm.deleteSlide;
            saveButtonTitle = strings.activityForm.saveSlide;
            break;
        case ActivityType.TASK:
        default:
            deleteButtonTitle = strings.activityForm.deleteTask;
            saveButtonTitle = strings.activityForm.saveTask;
            break;
    }

    const Buttons = (
        <>
            <Button
                title={deleteButtonTitle}
                aria={deleteButtonTitle}
                colour={'BLACK'}
                onClick={setDeleteAlertOpen}
                disabled={disableDeleteTaskButton}
                fullwidth={!fullWidth}
            />
            <Button
                type="submit"
                title={saveButtonTitle}
                aria={saveButtonTitle}
                disabled={disableSubmitButton}
                submitting={submitting}
                fullwidth={!fullWidth}
            />
        </>
    );

    const Notifications = (
        <>
            {showSavedSuccessfully && <SavedSuccessfullyNotification />}
            {showSavedSuccessfullyEditMode && <EditModeSaveNotification />}
            {globalErrorMessage && <ErrorNotifierSlim description={globalErrorMessage} />}
        </>
    );

    return (
        <FlexColMd>
            {showLastActivityInModuleWarning && (
                <FlexEnd>
                    <LastActivityInModuleWarning />
                </FlexEnd>
            )}
            <FlexColMd>
                {fullWidth ? (
                    <>
                        <FlexEnd>{Buttons}</FlexEnd>
                        <FlexEnd>{Notifications}</FlexEnd>
                    </>
                ) : (
                    <>
                        {Buttons}
                        {Notifications}
                    </>
                )}
            </FlexColMd>
        </FlexColMd>
    );
}

const FlexEnd = styled(FlexMd)`
    justify-content: end;
`;
